import React from "react";
import { formatJalali } from "../../routes/challenges/jalaliDate";
import "../../styles/Achievements.css";

// One badge - used in the catalog grid, the profile's featured row, and the
// user-preview modal. `achievement` follows the shape returned by
// GET achievements / GET users/{id}/achievements (earned entries there don't
// carry `progress`/`target`, which is fine - locked-only fields just no-op).
function AchievementCard({ achievement, size = "md", onClick }) {
  if (!achievement) return null;

  const earned = !!achievement.earned;
  const icon = achievement.icon && achievement.icon.trim() ? achievement.icon : "🏆";
  const hasTarget = achievement.target != null && achievement.target > 0;
  const progressPct = hasTarget
    ? Math.min(100, Math.round(((achievement.progress || 0) / achievement.target) * 100))
    : 0;

  return (
    <button
      type="button"
      className={`achievementCard achievementCard-${size} ${
        earned ? `achievementCard-earned achRarity-${achievement.rarity || "common"}` : "achievementCard-locked"
      }`}
      onClick={() => onClick && onClick(achievement)}
    >
      <span className="achievementCardIcon" aria-hidden="true">
        {icon}
      </span>
      <span className="achievementCardName yekan">{achievement.name}</span>

      {earned ? (
        achievement.earned_at && (
          <span className="achievementCardDate caption-2 yekan">
            {formatJalali(achievement.earned_at, "DD MMMM")}
          </span>
        )
      ) : (
        <>
          <span className="achievementCardLock" aria-hidden="true">
            🔒
          </span>
          {hasTarget && (
            <span className="achievementCardProgress" aria-hidden="true">
              <span className="achievementCardProgressFill" style={{ width: `${progressPct}%` }} />
            </span>
          )}
        </>
      )}
    </button>
  );
}

export default AchievementCard;
